import { FC } from 'react'

import './IPS404.scss'

export const IPS404: FC = () => {
  return (
    <div className="populus-404">
      <span>404</span>
    </div>
  )
}
